import React, { useState } from "react";

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  error?: string;
}

const TermsConsent: React.FC<Props> = ({ checked, onChange, error }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="p-4 bg-gray-50 border border-gray-200 rounded-lg">
      <label className="flex items-start gap-3 cursor-pointer">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="mt-1 w-4 h-4 accent-main flex-shrink-0 cursor-pointer"
        />
        <div className="flex-1">
          <span className="text-xs text-gray-600">
            I agree to BeMe Consulting's{" "}
            {/* <a href="/#/terms" className="underline text-main">
              Terms & Conditions
            </a>{" "} */}
            Terms & Condition
            and use of my personal data for service delivery and marketing.{" "}
          </span>
          <button
            type="button"
            onClick={() => setExpanded((v) => !v)}
            className="text-xs text-main underline underline-offset-2 hover:opacity-70 transition-opacity"
          >
            {expanded ? "Hide details ▲" : "See details ▼"}
          </button>
          {expanded && (
            <p className="mt-2 text-xs text-gray-400 leading-relaxed">
              By submitting this form, you consent to BeMe Consulting collecting and using
              your name, email, career details, and uploaded files solely to deliver the
              requested service. You also agree to receive service-related communications
              and occasional marketing updates. Anonymised or aggregated results (e.g. edited
              CV excerpts or job titles) may be used for portfolio, case study, or promotional
              purposes without identifying you personally. Purchased digital materials are for
              personal use only — redistribution or resale is strictly prohibited. Your data
              will not be shared with third parties without your consent. You may withdraw
              consent at any time by contacting{" "}
              <a href="mailto:info@bemeconsulting.com" className="underline">
                info@bemeconsulting.com
              </a>
              .
            </p>
          )}
        </div>
      </label>
      {error && <p className="text-red-500 text-xs mt-2 ml-7">{error}</p>}
    </div>
  );
};

export default TermsConsent;
